module.exports = __webpack_public_path__ + "img/vue_logo.96e5850d.png";